/* eslint-disable no-shadow,react/require-default-props */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getTradeUpProducts } from '../../../../appState/ducks/tradeUp';
import TradeUpContainer from './TradeUpContainer/TradeUpContainer';
import translations from '../translations';

const Wrapper = styled.div`
  margin-bottom: 75px;
`;

const Title = styled.div`
  font-family: Helvetica;
  font-size: 16px;
  font-weight: bold;
  color: color: ${({ theme }) => theme.colors.shades[2]};
  margin-top: 25px;
`;

const Divider = styled.hr`
  border: 1px solid #e7e7e7;
  height: 0;
  margin: 15px 0 15px 0;
`;

const TradeUp = ({
  getTradeUpProducts,
  tradeUpProducts,
  mainProductID,
  mainProductImageUrl,
  title,
  psaVariant
}) => {

  useEffect(() => {
    const mainProductInfo = {
      productID: mainProductID,
      imageUrl: mainProductImageUrl
    };
    getTradeUpProducts(mainProductInfo);
  }, [mainProductID]);

  return (
    tradeUpProducts.length === 3 && (
      <Wrapper>
        <Title>{title}</Title>
        <Divider />
        <TradeUpContainer
          products={tradeUpProducts}
          buttonCompareText={translations.buttonCompareText}
          buttonCompareOnClick={() => {}}
          psaVariant={psaVariant}
        />
      </Wrapper>
    )
  );
};

TradeUp.propTypes = {
  getTradeUpProducts: PropTypes.func.isRequired,
  tradeUpProducts: PropTypes.arrayOf(
    PropTypes.shape({
      isActualProduct: PropTypes.bool.isRequired,
      productTitle: PropTypes.string.isRequired,
      productImgUrl: PropTypes.string.isRequired,
      productUrl: PropTypes.string.isRequired,
      productParameters: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
          highlighted: PropTypes.bool.isRequired
        })
      ).isRequired,
      reviewsCount: PropTypes.number.isRequired,
      rating: PropTypes.number.isRequired,
      productId: PropTypes.string.isRequired,
      productPrice: PropTypes.number.isRequired,
      tradeUpPrice: PropTypes.number.isRequired,
      productCurrency: PropTypes.string,
      buttonText: PropTypes.string.isRequired,
      buttonOnClick: PropTypes.func.isRequired
    })
  ).isRequired,
  mainProductID: PropTypes.string,
  mainProductImageUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  psaVariant: PropTypes.string
};

TradeUp.defaultProps = {
  mainProductID: undefined,
  mainProductImageUrl: undefined
};

const mapDispatchToProps = (dispatch) => ({
  getTradeUpProducts: (mainProductInfo) => dispatch(getTradeUpProducts(mainProductInfo))
});

const mapStateToProps = ({ tradeUp, productInfo }) => ({
  tradeUpProducts: tradeUp.tradeUpProducts,
  mainProductID: productInfo.productID,
  mainProductImageUrl: productInfo.imageUrl
});

export default connect(mapStateToProps, mapDispatchToProps)(TradeUp);
